module.exports = __webpack_public_path__ + "img/132.6874f0ac.jpg";